<template>
  <!-- Contact Information Section -->
  <div class="section-container pb-2">
    <div
      class="section-title d-flex align-center px-6 py-3 subtitle-1 font-weight-medium"
    >
      <v-icon color="#FF6B35" class="mr-2">mdi-card-account-details</v-icon>
      <span>{{ $t("contact_info") }}</span>
    </div>
    <v-divider></v-divider>

    <div class="pa-5 d-flex" style="gap: 20px">
      <div class="flex-grow-1">
        <text-field v-model="model.address" :label="$t('address')" />
      </div>
      <div class="flex-grow-1">
        <text-field v-model="model.city" :label="$t('city')" />
      </div>
    </div>

    <!-- Contact Details -->
    <div class="pa-5 d-flex border-top" style="gap: 20px">
      <div class="flex-grow-1">
        <text-field v-model="model.email" :rules="[rules.email]" :label="$t('email')" />
      </div>
      <div class="flex-grow-1">
        <text-field v-model="model.phone" :rules="[rules.phone]" :label="$t('phone')" />
      </div>
    </div>

    <div class="pa-5 d-flex border-top" style="gap: 20px">
      <div class="flex-grow-1">
        <text-field v-model="model.contact_person" :label="$t('contact_person')" />
      </div>
    </div>

    <!-- Business Information -->
    <div class="pa-5 d-flex border-top" style="gap: 20px">
      <div class="flex-grow-1">
        <text-field
          v-model="model.pib"
          :rules="[rules.numberRule]"
          :label="$t('pib')"
        />
      </div>
      <div class="flex-grow-1">
        <text-field
          v-model="model.maticni_broj"
          :rules="[rules.numberRule]"
          :label="$t('jib')"
        />
      </div>
    </div>

    <div class="pa-5 border-top">
      <div class="flex-grow-1">
        <text-area
          v-model="model.description"
          :rows="3"
          :label="$t('company_description')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel.js";
import hasValidation from "@/mixins/hasValidation.js";

export default {
  name: "ContactInformation",
  mixins: [hasModel, hasValidation],
};
</script>

<style scoped>
/* Component specific styles if needed */
</style>
